
/* styles */
require("!!vue-style-loader!css-loader?minimize!./../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-4b172778!stylus-loader!./../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./Shortcutbar.vue")

var Component = require("!./../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!./../../../node_modules/vue-loader/lib/selector?type=script&index=0!./Shortcutbar.vue"),
  /* template */
  require("!!./../../../node_modules/vue-loader/lib/template-compiler?id=data-v-4b172778!./../../../node_modules/vue-loader/lib/selector?type=template&index=0!./Shortcutbar.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/navigation/Shortcutbar.vue
// module id = 202
// module chunks = 22